import PageContainer from './components/PageContainer';
import PageMenu from './components/PageMenu';
import './assets/scss/main.css';

export {PageMenu};

export default PageContainer;


// WEBPACK FOOTER //
// ./src/features/Content/index.js